// Small helpers shared across the extracted Settings sections.

/** Unwrap the various response envelopes the API returns ({data:{success}}, {success}, {data}). */
export const unwrap = (res: any) => {
  const body = res?.data?.success !== undefined ? res.data : (res?.success !== undefined ? res : res?.data || res);
  return body;
};
